export default "__VITE_ASSET__Dc58QpKu__"